import { render } from "./OtherRequests.vue?vue&type=template&id=7784342a&scoped=true"
import script from "./OtherRequests.vue?vue&type=script&lang=js"
export * from "./OtherRequests.vue?vue&type=script&lang=js"

import "./OtherRequests.vue?vue&type=style&index=0&id=7784342a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7784342a"]])

export default __exports__